import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "filter-section d-flex justify-content-start mb-4"
}
const _hoisted_2 = { class: "ps-1 mb-0" }
const _hoisted_3 = ["innerHTML"]

import { useDriveStore } from '@/modules/drive/store/driveStore';
import { descriptionWithLink } from '@/helpers/utils';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const driveStore = useDriveStore();

return (_ctx: any,_cache: any) => {
  return (_unref(driveStore).currentCase.labels.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(driveStore).currentCase.labels, (label) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "list-inline-item mt-1 ms-1",
              key: label.id,
              innerHTML: _unref(descriptionWithLink)(label.name)
            }, null, 8, _hoisted_3))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})